import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import classes from './../TrialstatNoto.module.css';
import InputString from '../UI/Control/InputString';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import SelectList from '../UI/Control/SelectList';

const OutcomeGlobalEmailModal = (props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        if (props.globEmailID > 0 ) {
            fetchOutcomeGlobalEmailData();
        }
        setShow(true);
    };


    const fetchOutcomeGlobalEmailData = () => {
        fetch('api/OutcomeNotification/GetGlobalOutcomeEmailsDetails?globEmailID=' + props.globEmailID)
            .then(response => response.json())
            .then(data => {
                setData(data);
            });
    }

    function setData(data) {
        document.getElementById('ddlOutcomeMapping').value = data.OutcomesMappingID;
        document.getElementById('txtEditEmail').value = data.EmailID;
    }

    function ValidateMapping() {
        let objOutcomeMapping = document.getElementById('ddlOutcomeMapping');
        if (objOutcomeMapping.value == '-1') {
            alert('Please select outcome mapping.');
            objOutcomeMapping.focus();
            return false;
        }

        let objEditEmail = document.getElementById('txtEditEmail');
        if (objEditEmail.value.trim() == '') {
            alert('Email should not be empty.');
            objEditEmail.focus();
            return false;
        }

        var re = /\S+@\S+\.\S+/;
        if (!re.test(objEditEmail.value)) {
            alert('Please provide valid email address.');
            objEditEmail.focus();
            return false;
        }
        return true;
    }

    const SaveMappingData = (event) => {
        let retVal = ValidateMapping();
        if (retVal == false)
            return false;

        let objGlobalOutcomeEmailsModel = {
            GlobEmailID: props.globEmailID,
            StudyID: props.studyId,
            EmailID: document.getElementById('txtEditEmail').value,
            OutcomesMappingID: document.getElementById('ddlOutcomeMapping').value
        }

        fetch('api/OutcomeNotification/SaveGlobalOutcomeEmails', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objGlobalOutcomeEmailsModel)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Email is not saved, Something went wrong.');
                return false;
            }

            if (res == -2) {
                alert('Email is already exist, try with different email.');
                return false;
            }

            if (res > 0) {
                setShow(false);
                props.fetchData(props.mappingId);
            }
        })

        return true;

    };

    return (
        <>
            <button className="btn btn-success" type="button" onClick={handleShow}> {props.text} </button>

            <Modal show={show} onHide={handleClose} dialogClassName={classes.TSModalDailog_Fourteen} animation={false} backdrop="static" style={{marginTop:"140px"}}>
                <Modal.Header className={classes.modalHeader}>
                    <div style={{ width: "100%" }}>
                        <Modal.Title>{props.header}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label>Outcome Mapping<MandatoryLabel />:</label>
                            <SelectList id="ddlOutcomeMapping" dataSource={props.outcomeMapp} style={{ marginTop: "5px" }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label>Email<MandatoryLabel />:</label>
                            <InputString id="txtEditEmail" maxlength="255" style={{ marginTop: "7px" }} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="" style={{ width: "100%" }}>
                        <Button variant="primary" className="btn btn-danger" onClick={handleClose} style={{ float: "right" }}>
                            Close
                            </Button>
                        {!props.disabled && (props.action == "add" || props.action == "edit") && <Button variant="secondary" className="btn btn-success" onClick={SaveMappingData} style={{ marginRight: "10px", float: "right" }}> Save </Button>}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default OutcomeGlobalEmailModal;